import type { ModuleNav } from '@saas/ui';

/** telephony のメニュー（SFA 段階 5 §9.4）。通話の一覧は業務メニュー、電話連携の設定（接続・内線・録音）は管理メニュー */
export const telephonyNav: ModuleNav = {
  module: 'telephony',
  items: [{ label: '通話', to: '/telephony/calls', icon: 'call', permission: ['telephony.call.read.own', 'telephony.call.read.team', 'telephony.call.read.all'], description: '着信・発信の記録と折り返し待ち' }],
  admin: [{ label: '電話連携', to: '/telephony/settings', icon: 'call', permission: ['telephony.settings.manage'], description: '電話サービスとの接続・内線と担当者・着信ポップ・録音' }],
};
